import React, { useState } from 'react'
import { ButtonsRight } from '../../../interfaces/UI'
import Tooltip from '../../utils/Tooltip';

interface MenuLeftSectionProps{
    viewButtons : ButtonsRight,
    openButtons : ButtonsRight
    setOpenButtons : ( state : ButtonsRight) => void
}

const MenuLeftSection = ({viewButtons, openButtons, setOpenButtons} : MenuLeftSectionProps )  => {
  const [fullScreen, setFulScreen] = useState(false);
    const openLeftMenu = () =>{
        const icoBtn : Element | null = document.querySelector(".js-btn-icon");
        const menu = document.querySelector(".js-nav");
        const asideBtn = document.querySelectorAll(".gui__group--right .aside-btn");
        const colRight = document.querySelector(".aside");

        if(icoBtn){
          icoBtn.classList.toggle("close-icon")
          setOpenButtons({
            optAuthor: false,
            optConfig: false,
            optFileDoc: false,
            optHelp: false,
            optIndex: false,
            optNotes: false,
            optReferences: false,
            optReviews: false
          })
        }
        menu && menu.classList.toggle("expand") 
        // if(asideBtn.classList.contains("focus")){
        //   item.classList.remove("focus");
        // }
        asideBtn && asideBtn.forEach((item) => {
          if (item.classList.contains("focus")) {
            item.classList.remove("focus");
          }
        //   console.log(item);
        })

        
        if (colRight && colRight.classList.contains("expanded")) {
          colRight.classList.remove("expanded");
          //asideBtn.classList.remove("focus");
        } else {
          //document.querySelector("#" + opt).classList.add("active");
        }

    }

    const doFullScreen =() => {
      if (document.fullscreenElement !== null) {
          // El modo fullscreen está activo
          document.exitFullscreen();
          setFulScreen(false)
      } else {
          // El modo fullscreen no está activo
          document.documentElement.requestFullscreen();
          setFulScreen(true)
        }
  }
        
    return (
        <div className="gui__group gui__group--top">
          <div className="gui__subgroup gui__subgroup--tl bg-sb">
            <div className="gui-module gui-module--align-center">
              <div className="gui-module__item">

              <Tooltip tip="Indice de contenidos">

                <button
                  type="button"
                  id="options-btn"
                  className="btn btn-rounded btn-rounded-transparent js-btn-aside tippy tourBtnLeftMenu"
                  data-tippy-content="Indice de contenidos"
                  aria-label="Indice de contenidos"

                  onClick = {openLeftMenu}

                >
                  <span className="btn__close-icon js-btn-icon"
                    ><span className="btn__icon-bar"></span>
                    <span className="btn__icon-bar"></span>
                    <span className="btn__icon-bar"></span
                  ></span>
                </button>
              </Tooltip>


              </div>
            </div>
          </div>
          <div className="gui__subgroup gui__subgroup--tr bg-sb hide-lg BtnFullScreen-BtnCustomizeMobile">
            <div className="gui-module gui-module--align-center">
              <div className="gui-module__item">
                <button type="button" onClick={doFullScreen} id="content-btn" className="btn btn-rounded btn-rounded-transparent aside-btn tippy" data-tippy-content="Pantalla completa" data-option="option-1" aria-label="Pantalla completa">
                  <span className="btn__icon"><i className="icon icon-vpro-enter-fullscreen"></i></span>
                </button>
              </div>
            </div>
          </div>
          {/* <!-- gui-top end --> */}
        </div>
    )
}

export default MenuLeftSection
